import {ComparatorBase} from "./ComparatorBase";
import * as React from "react";


export class EmptyComparator extends ComparatorBase{


    public GetComparator(){
        return <select style={{width:'100%', height:'auto',padding:0}} disabled={true}/>
    }

    public GetValueInput(){
        return <input value={''} style={{width:'100%',height:25}} type={'text'} disabled={true}/>
    }

    InitializeValues() {
    }

}